import styled from "styled-components";
import { useGetModuleConnectivityStatesQuery } from "../../../data/generated";
import { theme } from "../../../theme";
import { Loader } from "../../../design-system/atoms/Loader";
import { ModuleConnectivityDetailsRow } from "./ModuleConnectivityDetailsRow";

export const ModulesConnectivityList = ({
  moduleSerialNumberFilter,
}: {
  moduleSerialNumberFilter: string;
}) => {
  const { data, loading, error, fetchMore } =
    useGetModuleConnectivityStatesQuery({
      variables: {
        limit: 50,
        offset: 0,
        filters: { moduleSerialNumber: moduleSerialNumberFilter },
      },
      fetchPolicy: "cache-and-network",
    });

  if (error) {
    return null;
  }

  if (loading || !data) {
    return <Loader />;
  }

  const {
    moduleConnectivityStates: { moduleConnectivityStates, hasMore },
  } = data;

  function handleScroll({ currentTarget }: React.UIEvent<HTMLDivElement>) {
    if (
      currentTarget.scrollTop + currentTarget.clientHeight >=
      currentTarget.scrollHeight
    ) {
      if (hasMore) {
        fetchMore({
          variables: {
            offset: moduleConnectivityStates.length,
            limit: 20,
            filters: { moduleSerialNumber: moduleSerialNumberFilter },
          },
        });
      }
    }
  }

  return (
    <Container onScroll={handleScroll}>
      <Table>
        <thead>
          <Tr>
            <Th>Module Serial Number</Th>
            <Th>Connectivity Status</Th>
            <Th>Date</Th>
          </Tr>
        </thead>
        <tbody>
          {moduleConnectivityStates.map((moduleConnectivityState) => (
            <ModuleConnectivityDetailsRow
              key={moduleConnectivityState._id}
              moduleConnectivityState={moduleConnectivityState}
            />
          ))}
        </tbody>
      </Table>
      {moduleConnectivityStates.length === 0 && (
        <NoResultContainer>
          <p>No modules connectivity history</p>
        </NoResultContainer>
      )}
    </Container>
  );
};

const Container = styled.div`
  overflow-y: auto;
  border: 1px solid ${theme.borderColor.highlight};
  border-radius: 10px;
`;

const Table = styled.table`
  max-height: 100%;
  overflow-x: auto;
`;

const Tr = styled.tr`
  background-color: ${theme.backgroundColor};
`;

const Th = styled.td<{ $isCentered?: boolean }>`
  position: sticky;
  top: 0px;
  background-color: ${theme.backgroundColor};
  font-weight: bold;
  text-align: ${({ $isCentered }) => ($isCentered ? "center" : "left")};
  padding: 5px;
`;

const NoResultContainer = styled.div`
  display: flex;
  justify-content: center;
  color: ${theme.textColor.secondary};
`;
